import React from "react";
import TestimonialsData from "./TestinomialsData.json";
import Marquee from "react-fast-marquee";

const Testimonials = () => {
  return (
    <div className="flex flex-col h-auto lg:gap-[104px] gap-8 lg:justify-center lg:items-center lg:px-0 px-5 lg:mt-16 mt-20">
      <div className="flex flex-col gap-2 leading-[150%] justify-center lg:items-center relative">
        <div className="absolute flex items-center justify-center lg:w-[110px] w-[73px]  lg:h-20 h-14 lg:-left-40 lg:-top-4 -top-20">
          <img src="/Images/assets/Comma.svg" alt="" />
        </div>
        <h2 className="font-bold lg:text-4xl text-[28px] text-[#E5204B]">
          Testimonials
        </h2>
        <h5 className="font-medium lg:text-xl text-base text-[#606C80]">
          Our Awesome Clients
        </h5>
      </div>

      <Marquee
        speed={20}
        direction="right"
        gradient={true}
        gradientWidth={30}
        pauseOnHover="true"
        className="h-[400px]"
      >
        <div className="flex gap-[116px] ">
          {TestimonialsData.map((data, index) => (
            <div
              id="data.id"
              className="relative lg:w-[660px] w-[315px] h-[328px] lg:h-[314px] rounded-3xl p-6 gap-[10px] flex flex-col manual-shadow last:mr-[116px]"
            >
              <div className="flex flex-col gap-6">
                <h3 className="font-medium lg:text-2xl text-lg text-[#E5204B]">
                  {data.title}
                </h3>
                <p className="lg:text-base text-xs text-[#464558] leading-[145%]">
                  {data.desc}
                </p>
              </div>
              <div className="lg:w-[612px] w-[267px] flex justify-between items-center absolute bottom-6">
                <span className="flex gap-1 items-center ">
                  {Array.from({ length: data.rating }).map((_, index) => (
                    <>
                      <span className="flex lg:hidden  items-center justify-center lg:w-5 lg:h-5 w-3 h-3 ">
                        <img
                          key={index}
                          src="/Images/assets/star.svg"
                          alt="star"
                        />
                      </span>

                      <img
                        key={index}
                        src="/Images/assets/star.svg"
                        alt="star"
                        className="lg:block hidden"
                      />
                    </>
                  ))}
                </span>
                <div className="flex gap-3 items-center">
                  <div className="flex flex-col lg:text-base text-[10px] text-right">
                    <h3 className="font-bold ">{data.name}</h3>
                    <h6 className="">{data.designation}</h6>
                  </div>
                  <div className="lg:w-14 w-8 h-9 lg:h-14 rounded-full overflow-hidden">
                    <img
                      src={`/Images/testimonials/image${index + 1}.jpg`}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default Testimonials;
